"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CartItem = void 0;
var CartItem = /** @class */ (function () {
    function CartItem(cart, data) {
        this.cart = cart;
        this.id = data.id;
        this.variantId = data.variant_id;
        this.quantity = data.quantity;
        this.properties = data.properties;
        this.productId = data.product_id;
        this.key = data.key;
        this.title = data.title;
        this.price = data.price;
        this.linePrice = data.line_price;
        this.finalPrice = data.final_price;
        this.finalLinePrice = data.final_line_price;
        this.sku = data.sku;
        this.grams = data.grams;
        this.vendor = data.vendor;
        this.taxable = data.taxable;
        this.productHasOnlyDefaultVariant = data.product_has_only_default_variant;
        this.giftCard = data.gift_card;
        this.url = data.url;
        this.featuredImage = data.featured_image ? {
            url: data.featured_image.url,
            aspectRatio: data.featured_image.aspect_ratio,
            alt: data.featured_image.alt,
        } : null;
        this.image = data.image;
        this.handle = data.handle;
        this.requiresShipping = data.requires_shipping;
        this.productTitle = data.product_title;
        this.productDescription = data.product_description;
        this.productType = data.product_type;
        this.variantTitle = data.variant_title;
        this.variantOptions = data.variant_options;
        this.optionsWithValues = data.options_with_values;
    }
    // Update the item in the cart
    CartItem.prototype.changeQuantity = function (quantity) {
        return this.change(quantity, null);
    };
    CartItem.prototype.changeProperties = function (properties) {
        return this.change(null, properties);
    };
    CartItem.prototype.change = function (quantity, properties) {
        return this.cart.changeItem(this, quantity, properties);
    };
    // Remove items from the cart
    CartItem.prototype.remove = function () {
        return this.cart.removeItem(this);
    };
    return CartItem;
}());
exports.CartItem = CartItem;
//# sourceMappingURL=CartItem.js.map